import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const NyukinKinshuKbn = props => {
  return <Dropdown.Static kubunKey='nyukin_kinshu_kbn' {...props} />
}
